
import { DataTable, DataTableResource, DataTableTranslations } from 'angular7-data-table';
import { NgbModalRef, NgbModalOptions, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit } from '@angular/core';
import { CdkDragDrop, moveItemInArray, CdkDragExit } from '@angular/cdk/drag-drop';
import { Router, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CommonService } from "../../../common/common.service";
import { CourseManagementService } from "../course-management.service"
import { NgxSpinnerService } from "ngx-spinner";
import { HttpResponse } from "@angular/common/http";
import Swal from "sweetalert2";

@Component({
  selector: 'app-view-course-detail',
  templateUrl: './view-course-detail.component.html',
  styleUrls: ['./view-course-detail.component.css'],
})

export class ViewCourseDetailComponent implements OnInit {

  courseDetailForm: FormGroup;
  formSubmitted: boolean = false;
  showLessonError: boolean = true;
  showWeekError: boolean = true;
  showAdditionalError: boolean = true;
  isDisabled: boolean = true;

  lessonId: any;
  selectedFile: any;
  uploadcourseImage: any;
  courseId: string;
  lessonCount: any;
  courseDetailReq = {
    courseId: null,
    title: null,
    weekLabel: null,
    week: null,
    imageUrl: null,
    videoUrl: null,
    sortOrder: null,
    description: null,
    lessonTopics: [],
    weeksActionSteps: [],
    additionalResources: []
  }
  lessonTopicList = [];
  weeksActionStepList = [];
  additonalResourseList = [];
  typelist = [
    { value: 'normal', viewValue: 'Normal' },
    { value: 'webview', viewValue: 'Web View' },
    { value: 'docview', viewValue: 'Doc View' },
  ];

  courseDetailList = []
  private modalRef: NgbModalRef;

  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false
  };
  statusList: Array<object> = [
    { id: "active", name: "Active" },
    { id: "inactive", name: "Inactive" },
    { id: "Block", name: "Block" }
  ];
  closeResult: string;
  statusFormSubmitted: boolean = false;
  courseDetail: any;
  statusForm: FormGroup;
  featureList = [];
  finalFeatureList = [];
  temp: any;
  feature: string;
  constructor(private formBuilder: FormBuilder, private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private commonService: CommonService,
    private CourseManagementService: CourseManagementService) { }

  ngOnInit() {
    this.courseId = this.route.snapshot.params["course_Id"];
    this.spinner.show();
    // this.startLoadingSpinner();
    this.initialiseForms();
    this.getLessonByCourseId(this.courseId);
  }
  startLoadingSpinner() {

    setTimeout(function () {
      this.spinner.hide();
    }.bind(this), 3000);
  }
  getLessonByCourseId(id: any) {
    this.spinner.show();
    this.CourseManagementService.getlessonListById(id).subscribe(res => {

      if ((res["message"] = "Success")) {
        this.courseDetailList = res.data.courseDetailList;
        this.lessonCount = this.courseDetailList.length;
        this.spinner.hide();
      } else {
        this.spinner.hide();
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });
      }
    });

  }


  initialiseForms() {
    this.courseDetailForm = this.fb.group({
      title: ["", [Validators.required]],
      weekLabel: ["", [Validators.required]],
      week: ["", [Validators.required]],
      imageUrl: [, [Validators]],
      videoUrl: [, [Validators.required]],
      sortOrder: [, [Validators.required]],
      description: [, [Validators.required]],
      lessonDescription: [, [Validators]],
      weekDescription: [, [Validators]],
      additionalDescrption: [, [Validators]],
      additionalType: [, [Validators]],
      additionalWebViewUrl: [, [Validators]],
    });
  }


  labels = <DataTableTranslations>{
    paginationText: 'Your table displays {from} to {to} of {total} rows.'
  };



  updateForm() {
    this.courseDetailForm.patchValue({
      title: this.courseDetail["title"],
      weekLabel: this.courseDetail["weekLabel"],
      week: this.courseDetail["week"],
      imageUrl: this.courseDetail["imageUrl"],
      videoUrl: this.courseDetail["videoUrl"],
      sortOrder: this.courseDetail["sortOrder"],
      description: this.courseDetail["description"],

    });

    this.courseDetail.lessonTopics.forEach((element) => {
      this.lessonTopicList.push(element.description);
      this.showLessonError = false;
    });
    this.courseDetail.weeksActionSteps.forEach((element) => {
      this.weeksActionStepList.push(element.description);
      this.showWeekError = false;
    });
    this.additonalResourseList = this.courseDetail.additionalResources;
    this.showLessonError = false;

  }


  updateCourseDetailModal(row, content, btn) {
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();

    this.courseDetail = row;
    this.updateForm();
    this.statusFormSubmitted = false;
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
  deleteStatusModal(row, content, btn) {
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
    this.lessonId = row;
    this.courseDetail = row;
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  deleteRecord(record: any) {
    this.spinner.show();
    this.CourseManagementService.deleteLesson(this.lessonId).subscribe(res => {
      if ((res["status"] = "Success")) {
        Swal.fire("Success", "Lesson Deleted successfully!", "success");
        this.modalRef.close();
        this.spinner.hide();
        this.getLessonByCourseId(this.courseId);
      } else {
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });

      }
    });
    this.spinner.hide();

  }


}
